import { useTranslation } from 'react-i18next'

import { QA_SECTION_KEY } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import { ScrollSlider } from '../../ScrollSlider'
import { Tab } from '../Tab'

import { TAB_SCROLL_LIST_SCROLL_STEP } from './TabScrollList.constants'
import { TabScrollListButtons } from './TabScrollListButtons'

import * as styles from './TabScrollList.module.css'

function TabScrollList({
  Buttons = TabScrollListButtons,
  activeTab,
  contentClassName = styles.TabScrollList,
  getTabs,
  preparedTabs,
  sectionQaName,
  tabProps,
  wrapperClassName = styles.wrapper,
  onSetActiveTab,
}) {
  const { t } = useTranslation()

  const tabs = preparedTabs || getTabs(t)

  const sectionQaProps = sectionQaName
    ? getQaSelector({ value: sectionQaName }, QA_SECTION_KEY)
    : null

  function getHandleSetActive(name) {
    return () => onSetActiveTab(name)
  }

  return (
    <ScrollSlider
      withWheelScroll
      Buttons={Buttons}
      className={wrapperClassName}
      contentClassName={contentClassName}
      itemGap={0}
      itemWidth={TAB_SCROLL_LIST_SCROLL_STEP}
    >
      <div {...sectionQaProps} className={styles.content}>
        {tabs.map(tab => (
          <Tab
            {...tabProps}
            {...tab}
            withScrollIntoView
            isActive={activeTab === tab.id}
            key={tab.id}
            onClick={getHandleSetActive(tab.id)}
          />
        ))}
      </div>
    </ScrollSlider>
  )
}

export default TabScrollList
